import React from 'react';
import { UploadProgress } from '@/types/models';
import { Upload, Button, Progress } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useFileUpload } from '@/hooks/useFileUpload';
import { useFiles } from '@/contexts/FileContext';
import { FILE_CONFIG } from '@/constants/file.constants';
import { UploadContainer } from './styles/FileUpload.styles';

interface FileUploadProps {
  tournamentId: number;
}

export const FileUpload: React.FC<FileUploadProps> = ({ tournamentId }) => {
  const { uploadProgress } = useFiles();
  const { uploading, handleUpload } = useFileUpload(tournamentId);

  return (
    <UploadContainer>
      <Upload
        customRequest={({ file, onSuccess }) => {
          handleUpload(file as File)
            .then(() => onSuccess?.('OK'))
            .catch(() => {});
        }}
        accept={FILE_CONFIG.UPLOAD.EXTENSIONS.join(',')}
        maxCount={5}
        multiple
        showUploadList={false}
      >
        <Button
          icon={<UploadOutlined />}
          loading={uploading}
        >
          Загрузить файлы
        </Button>
      </Upload>

      {uploadProgress && Object.entries(uploadProgress).map(([fileId, progress]: [string, UploadProgress]) => (
        <Progress
          key={fileId}
          percent={progress.percent}
          status={
            progress.status === 'error'
              ? 'exception'
              : progress.status === 'done'
                ? 'success'
                : 'active'
          }
        />
      ))}
    </UploadContainer>
  );
};